import StarVisualization from './StarVisualization';
import './StarVisualization.scss';

export { schema, uiSchema } from '../schemas/StarVisualizationSchema';
export default StarVisualization;
